import type { Project } from '../api/generated/schemas/project'

export const developerLogos: Record<string, string> = {
  'Segrex Development L.L.C Агентство':
    'https://avatars.mds.yandex.net/i?id=70d28def6aafbd8f46b5a6028a7218f0_l-5310919-images-thumbs&n=13',
  'Major Developments':
    'https://avatars.mds.yandex.net/i?id=c6a1772c7effeac59b29a17ea8103e7133ae2d79-9151820-images-thumbs&n=13',
  'DIA Developments': 'https://novostroyki.bazametrov.ru/storage/uploads/developers/2052/logo.jpg',
  'Emaar Properties':
    'https://avatars.mds.yandex.net/i?id=6106b51626c0974294528879d7d72c1d_l-5670589-images-thumbs&n=13',
}

export const mockProperties: (Project & { districtId?: string })[] = [
  {
    id: 'sea-legend-tower-one',
    slug: 'sea-legend-tower-one',
    name: 'Sea Legend Tower One: Меблированная 3-комнатная квартира',
    area: { name: 'Dubai Marina' },
    developer: { name: 'Segrex Development L.L.C Агентство' },
    priceFromUs: 1200000,
    currency: 'AED',
    propertyTypes: ['Apartment'],
    bedrooms: ['3К'],
    completionDate: '2025-12-31',
    areaSize: 1533.25,
    areaUnit: 'sq. ft.',
    media: {
      cover: { url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800' },
      logo: { url: developerLogos['Segrex Development L.L.C Агентство'] },
    },
    tags: ['9 декабря', 'Акция для клиентов'],
    isFeatured: true,
    description:
      'Полностью меблированная 3-комнатная квартира площадью 1,533.25 sq. ft. в Sea Legend Tower One',
    lat: 25.0772,
    lng: 55.1398,
    sale: 'start of sales',
    status: 'active',
    districtId: 'dubai-marina',
  },
  {
    id: 'colibri-views',
    slug: 'colibri-views',
    name: 'Colibri Views',
    area: { name: 'Al Jazeera Al Hamra Industrial' },
    developer: { name: 'Major Developments' },
    priceFromUs: 1100000,
    currency: 'AED',
    propertyTypes: ['Apartment', 'Penthouse'],
    bedrooms: ['Ст', '1К', '2К'],
    completionDate: '2029-Q1',
    areaSize: 0,
    areaUnit: '',
    media: {
      cover: { url: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800' },
      logo: { url: developerLogos['Major Developments'] },
    },
    lat: 25.334,
    lng: 55.307,
    sale: 'sales announcement',
    status: 'active',
  },
  {
    id: 'luz-ora-residences',
    slug: 'luz-ora-residences',
    name: 'Luz Ora Residences',
    area: { name: 'Dubai Islands' },
    developer: { name: 'DIA Developments' },
    priceFromUs: 1600000,
    currency: 'AED',
    propertyTypes: ['Apartment', 'Duplex'],
    bedrooms: ['1К', '2К', '4К'],
    completionDate: '2027-Q2',
    areaSize: 0,
    areaUnit: '',
    media: {
      cover: { url: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800' },
      logo: { url: developerLogos['DIA Developments'] },
    },
    lat: 25.3216,
    lng: 55.2911,
    sale: 'sale',
    status: 'active',
  },
  {
    id: 'palm-jumeirah-residence',
    slug: 'palm-jumeirah-residence',
    name: 'Palm Jumeirah Residence',
    area: { name: 'Palm Jumeirah' },
    developer: { name: 'Emaar Properties' },
    priceFromUs: 2500000,
    currency: 'AED',
    propertyTypes: ['Villa', 'Townhouse'],
    bedrooms: ['2К', '3К', '4К'],
    completionDate: '2026-Q3',
    areaSize: 0,
    areaUnit: '',
    media: {
      cover: { url: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800' },
    },
    lat: 25.1154,
    lng: 55.139,
    sale: 'sale',
    status: 'active',
    districtId: 'palm-jumeirah',
  },
  {
    id: 'downtown-dubai-tower',
    slug: 'downtown-dubai-tower',
    name: 'Downtown Dubai Tower',
    area: { name: 'Downtown Dubai' },
    developer: { name: 'Emaar Properties' },
    priceFromUs: 1800000,
    currency: 'AED',
    propertyTypes: ['Apartment', 'Penthouse'],
    bedrooms: ['1К', '2К', '3К'],
    completionDate: '2028-Q1',
    areaSize: 0,
    areaUnit: '',
    media: {
      cover: { url: 'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800' },
    },
    lat: 25.1972,
    lng: 55.2744,
    sale: 'sale',
    status: 'active',
    districtId: 'downtown-dubai',
  },
]

export const featuredProperties = mockProperties.filter(p => p.isFeatured && p.status === 'active')
